<div class="download">
    <a [href]="'/' + block.data.documentId ? block.data.documentId : block.data.buttonLink"
       target="{{block.data.target}}">
      <img src="/assets/img/icons/downloads-arrow.png" alt="Download icon">
      <span *ngIf="block.data.downloadText">{{block.data.downloadText}}</span>
    </a>
  </div>
  